
import { AvenyThemeSpacing } from '../ThemeProvider/AvenyTheme';

const style = {
  display: 'flex',
  marginLeft: AvenyThemeSpacing,
  marginRight: AvenyThemeSpacing,
};

const hiddenStyle = {
  display: 'none',
};

interface IProps {
  hidden?: boolean;
}

export const EDBreadcrumbSeparator: React.FC<
  React.PropsWithChildren<IProps>
> = props => {
  return (
    <span aria-hidden style={props.hidden ? hiddenStyle : style}>
      /
    </span>
  );
};
